<template>
  <div v-if="product != null && prices != null">
    <div v-if="product.has_list">
      <section class="text_center">
        <h2 class="header_underline">クレジットカード①で購入</h2>

        <p class="text_left">下記でご希望の購入額をご選択の上、《確認画面へ》を押してください。</p>
      </section>
      <section class="text_center">
        <h3>決済金額選択</h3>

        <ValidationObserver ref="form">
          <form
            action=""
            method="post"
            class="form"
          >
            <div class="form_group">
              <ValidationProvider name="決済金額" rules="required" v-slot="{ errors }">
                <div class="select">
                  <select
                    name="priceId"
                    :class="{
                      select_placeholder: true,
                      selected: form.priceId !== ''
                    }"
                    v-model="form.priceId"
                  >
                    <option value="">金額を選択してください</option>
                    <option
                      v-for="(entry, index) in prices"
                      :key="index"
                      :value="entry.id"
                    >
                      {{ entry.price.toLocaleString() }}円
                    </option>
                  </select>
                </div>
                <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div>
              <p v-if="form.errors.length > 0" class="form_error">
                <span v-for="(error, index) in form.errors" :key="index" class="valid_error">{{ error }}</span>
              </p>
              <p>
                <button
                  type="submit"
                  class="btn arrow"
                  :disabled="isSend"
                  @click.prevent="checkForm"
                >確認画面へ</button>
              </p>
            </div>
          </form>
        </ValidationObserver>

        <div class="caution pa-2">
          <p class="text_left font_annotation--text mb-0">
            ※ウェブコインクレジットは米ドル建て決済のため、為替相場の変動により請求金額はお申込みの金額と多少誤差が御座います。<br>
            ※利用上限に関して<br>
            ↓<br>
            1日の上限回数：3回<br>
            1ヶ月の上限回数：10回(毎月1日に上限リセット)<br>
            上限金額：30日間で20万円迄
          </p>
        </div>
        <div class="annotation text_left">
          <h4><v-icon color="font_annotation">mdi-alert-circle-outline</v-icon>クレジットカード決済のご注意</h4>
          <p>
            クレジット決済にはメールアドレスの登録が必須です。メールアドレスを登録していない場合、下記のリンクからメールアドレスのご登録をお願い致します。
          </p>
          <p class="equality_margin text_center">
            <router-link :to="{ name: 'UserMailChange' }" class="arrow link_sub--text">メールアドレス登録はこちら</router-link>
          </p>
        </div>
      </section>
      <section class="add_point text_center">
        <h3>追加ポイント表</h3>

        <table class="table white brown border text_left">
          <tr>
            <th>購入額</th>
            <th>追加ポイント数</th>
          </tr>
          <tr>
            <td>500円</td>
            <td>50pt</td>
          </tr>
          <tr>
            <td>1,500円</td>
            <td>150pt</td>
          </tr>
          <tr>
            <td>3,000円</td>
            <td>300pt</td>
          </tr>
          <tr>
            <td>5,000円</td>
            <td class="caution--text">505pt</td>
          </tr>
          <tr>
            <td>10,000円</td>
            <td class="caution--text">1020pt</td>
          </tr>
          <tr>
          <td>20,000円</td>
          <td class="caution--text">2050pt</td>
          </tr>
          <tr>
            <td>30,000円</td>
            <td class="caution--text">3080pt</td>
          </tr>
          <tr>
            <td>50,000円</td>
            <td class="caution--text">5150pt</td>
          </tr>
          <tr>
            <td>70,000円</td>
            <td class="caution--text">7200pt</td>
          </tr>
          <tr>
            <td>100,000円</td>
            <td class="caution--text">10320pt</td>
          </tr>
        </table>
        <p class="text_left">
          ※上記は通常時の追加ポイントとなります。<br>
          キャンペーン等が適用されると更にお得です。
        </p>
      </section>
      <section class="no_mb no_padding text_center">
        <h3>お問い合わせ</h3>
        <div class="point_support">
          <p class="text_left">ご不明点などありましたら下記へお気軽にご連絡ください</p>
          <table class="support_info text_left">
            <tr>
              <th>お電話</th>
              <td>：<span class="telephone_num">{{ info.telephone }}</span></td>
            </tr>
            <tr>
              <th>メール</th>
              <td>：<a :href="`mailto:${settingData.inquiry_mail}?subject=${mailSubject}&amp;body=${mailBody}`" class="link_main--text text-decoration-underline">こちらから</a></td>
            </tr>
          </table>
          <div class="notice text_left">
            <p>お電話でのお問い合わせの際は下記の「会員ID」が必要になりますので、会員IDをお控えの上ご連絡ください。</p>
          </div>
          <table class="table white">
            <tr>
              <th>会員ID</th>
              <td>{{ user.user.id }}</td>
            </tr>
          </table>
        </div>
      </section>
    </div>
    <div v-else>
      <section class="suspension text_center">
        <p>準備中</p>
        <p><router-link to="/" class="decoration_link_arrow_blue">トップページへ戻る</router-link></p>
      </section>
    </div>
  </div>
</template>

<script>
import {
  GET_PRODUCT,
  GET_PRICE_LIST,
  GET_ORDER
} from '@/store/point/actions'

import {
  ValidationObserver,
  ValidationProvider,
  extend
} from 'vee-validate'
import {
  required
} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: '{_field_}を選択してください'
})

export default {
  name: 'PointCreditForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null,
      paymentWay: this.$route.params.paymentWay || null,
      product: null,
      prices: null,
      form: {
        errors: [],
        priceId: ''
      },
      isSend: false,
      settingData: []
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    },
    mailSubject () {
      return `入金問い合わせ[${this.user.user.id}]`
    },
    mailBody () {
      return `会員ID：${this.user.user.id}`
    }
  },
  methods: {
    getProduct () {
      this.$store.dispatch(GET_PRODUCT, {
        paymentWay: this.paymentWay
      })
        .then((data) => {
          this.product = data

          if (!data.has_list) {
            this.$router.push({ name: 'PointPurchase' })
          }
        })
        .catch(() => {
          this.$router.push({ name: 'PointPurchase' })
        })
    },
    getPrices () {
      this.$store.dispatch(GET_PRICE_LIST, {
        paymentWay: this.paymentWay
      })
        .then((data) => {
          this.prices = data.prices
        })
        .catch(() => {
          this.$router.push({ name: 'PointPurchase' })
        })
    },
    checkForm () {
      if (this.isSend) return
      this.isSend = true

      this.$refs.form.validate().then(success => {
        if (success) {
          this.getOrder()
        } else {
          this.isSend = false
        }
      })
    },
    getOrder () {
      this.$store.dispatch(GET_ORDER, {
        payment_way: this.paymentWay,
        price_id: this.form.priceId
      })
        .then((data) => {
          this.$router.pushIsses({
            name: 'PointCreditConfirm',
            params: {
              order: data,
              product: this.product
            }
          })
        })
        .catch((error) => {
          this.isSend = false
          this.form.errors = []

          this.form.errors.push(error.message)
        })
    },
    getDefaultSetting () {
      this.$store.dispatch('getDefaultSetting')
        .then((data) => {
          this.settingData = data
        })
    }
  },
  created () {
    this.getProduct()
    this.getPrices()
    this.getDefaultSetting()
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  }
}
</script>
